import React, { useEffect } from 'react';
import Navbar from '../../../Components/HomeComponent/Navbar';
import FooterComponent from '../../../Components/Footer/FooterComponent';
import { FaClock, FaReply, FaLink, FaChartPie, FaArrowRight } from 'react-icons/fa';

const FollowUpManagement = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "AI Follow-Up Management | ToxBox";
  }, []);

  const features = [
    {
      icon: <FaClock size={32} color="#ec4899" />,
      title: "Smart Scheduling",
      description: "Determine the optimal time to send emails or messages to maximize open rates."
    },
    {
      icon: <FaReply size={32} color="#ec4899" />,
      title: "Auto-Response Handling",
      description: "Detect typical responses (Out of Office, Not Interested) and handle them automatically."
    },
    {
      icon: <FaLink size={32} color="#ec4899" />,
      title: "Multi-Channel Sequences",
      description: "Orchestrate follow-ups across Email, LinkedIn, SMS, and WhatsApp seamlessly."
    },
    {
      icon: <FaChartPie size={32} color="#ec4899" />,
      title: "Engagement Tracking",
      description: "Monitor clicks, opens, and replies to understand what’s working and what’s not."
    }
  ];

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", backgroundColor: '#f8fafc', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />

      {/* Hero Section */}
      <div style={{
        padding: '160px 20px 100px',
        background: 'linear-gradient(135deg, #fdf2f8 0%, #ffffff 100%)',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: '800',
            color: '#831843',
            marginBottom: '24px',
            lineHeight: '1.2'
          }}>
            Never Drop the Ball on <br />
            <span style={{ color: '#db2777' }}>Sales Follow-Ups</span>
          </h1>
          <p style={{
            fontSize: '1.25rem',
            color: '#4b5563',
            marginBottom: '40px',
            maxWidth: '700px',
            margin: '0 auto 40px',
            lineHeight: '1.6'
          }}>
            Automate your follow-up persistence. Toxbox AI ensures every lead gets the attention they need until they convert.
          </p>
          <a href="/demo-form" style={{
            padding: '16px 36px',
            background: '#db2777',
            color: 'white',
            borderRadius: '50px',
            fontWeight: '700',
            textDecoration: 'none',
            boxShadow: '0 10px 20px -5px rgba(219, 39, 119, 0.4)'
          }}>
            Start Automating
          </a>
        </div>
      </div>

      {/* Features Grid */}
      <div style={{ padding: '100px 20px', background: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '80px' }}>
            <h2 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#1e293b' }}>Persistence Pays Off</h2>
            <p style={{ color: '#64748b', fontSize: '1.1rem', marginTop: '10px' }}>80% of sales require 5 follow-ups. We make that easy.</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '32px' }}>
            {features.map((item, index) => (
              <div key={index} style={{
                padding: '32px',
                borderRadius: '24px',
                background: '#fdf2f8',
                border: '1px solid #fce7f3',
                textAlign: 'left'
              }}>
                <div style={{ marginBottom: '20px' }}>{item.icon}</div>
                <h3 style={{ fontSize: '1.4rem', fontWeight: '700', color: '#831843', marginBottom: '12px' }}>{item.title}</h3>
                <p style={{ color: '#64748b', lineHeight: '1.6' }}>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div style={{ padding: '100px 20px', background: '#831843', color: 'white' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '60px' }}>The Power of Automated Follow-Ups</h2>
          <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '60px' }}>
            <div>
              <div style={{ fontSize: '4rem', fontWeight: '800', color: '#fbcfe8' }}>3x</div>
              <p style={{ fontSize: '1.2rem', marginTop: '10px' }}>More Meetings Booked</p>
            </div>
            <div>
              <div style={{ fontSize: '4rem', fontWeight: '800', color: '#fbcfe8' }}>10h+</div>
              <p style={{ fontSize: '1.2rem', marginTop: '10px' }}>Saved Per Rep/Week</p>
            </div>
            <div>
              <div style={{ fontSize: '4rem', fontWeight: '800', color: '#fbcfe8' }}>45%</div>
              <p style={{ fontSize: '1.2rem', marginTop: '10px' }}>Higher Response Rate</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer CTA */}
      <div style={{ padding: '80px 20px', textAlign: 'center', background: '#f8fafc' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: '800', color: '#1e293b', marginBottom: '20px' }}>Stop Leaking Revenue</h2>
        <a href="/contact" style={{
          display: 'inline-flex', alignItems: 'center', gap: '10px',
          color: '#db2777', fontWeight: '700', fontSize: '1.2rem', textDecoration: 'none'
        }}>
          Get Your Follow-Up Strategy <FaArrowRight />
        </a>
      </div>

      <FooterComponent />
    </div>
  );
};

export default FollowUpManagement;
